// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"0b54f1b9","977":"88494538"}[chunkId] + ".chunk.js";
};